import { render, staticRenderFns } from "./sortableItem.vue?vue&type=template&id=20646a41&scoped=true"
import script from "./sortableItem.vue?vue&type=script&lang=js"
export * from "./sortableItem.vue?vue&type=script&lang=js"
import style0 from "./sortableItem.vue?vue&type=style&index=0&id=20646a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20646a41",
  null
  
)

export default component.exports